// extracted by mini-css-extract-plugin
export default {"formContainer":"ForgotForm_formContainer__PahVg","actions":"ForgotForm_actions__Ym3DK"};